import { render, staticRenderFns } from "./lifeOrderList.vue?vue&type=template&id=5c8b6c92&scoped=true&"
import script from "./lifeOrderList.vue?vue&type=script&lang=js&"
export * from "./lifeOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8b6c92",
  null
  
)

export default component.exports